<template>
  <div>
    <DashboardHeader title="Finance Dashboard">
      <v-layout row wrap>
        <v-flex xs12 sm2>
          <v-card class="mx-4 mt-4" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <span class="ml-4 mt-4">Period From :</span>
            <v-list-item three-line style="margin-top:-4" class="mt-0">
              <DatePickerWithMenu @date-selected="getFromDate"></DatePickerWithMenu>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-4" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <span class="ml-4 mt-4">Period To :</span>
            <v-list-item three-line>
              <DatePickerWithMenu @date-selected="getToDate" :default="dateTo"></DatePickerWithMenu>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-4" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-list-item three-line>
              <v-select
                :items="charts"
                label="Select Chart"
                v-model="selectedChart"
                @change="getChartType()"
              ></v-select>
            </v-list-item>
          </v-card>

          <v-card class="mx-4 mt-4" v-if="isManager" shaped elevation="12" max-width="344" outlined>
            <v-list-item three-line>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>Expenses Categories</v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-for="(expCat,eid) in expensesCategories"
                    :key="eid+Math.random()"
                  >
                    {{expCat.name}}
                    <v-checkbox
                      class="shrink"
                      :value="expCat.id"
                      v-model="selectedExpensesCategories"
                      @change="renderCharts()"
                    ></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Incomes Categories</v-expansion-panel-header>
                  <v-expansion-panel-content
                    v-for="(incCat,iid) in incomesCategories"
                    :key="iid+Math.random()"
                  >
                    {{incCat.name}}
                    <v-checkbox
                      class="shrink"
                      :value="incCat.id"
                      v-model="selectedIncomesCategories"
                      @change="renderCharts()"
                    ></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-list-item>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <div class="mx-6">
                <h6 class="mt-8">Incomes</h6>
                <column-chart :data="incomesData" v-if="chartType == 'column'"></column-chart>
                <bar-chart :data="incomesData" v-else-if="chartType == 'bar'"></bar-chart>
                <line-chart :data="incomesData" v-else-if="chartType == 'line'"></line-chart>
                <pie-chart :data="incomesData" v-else-if="chartType == 'pie'"></pie-chart>
                <scatter-chart :data="incomesData" v-else-if="chartType == 'scatter'"></scatter-chart>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm12 class="mx-6">
              <div class="mx-6">
                <h6 class="mt-8">Expenses</h6>
                <column-chart :data="expensesData" v-if="chartType == 'column'"></column-chart>
                <bar-chart :data="expensesData" v-else-if="chartType == 'bar'"></bar-chart>
                <line-chart :data="expensesData" v-else-if="chartType == 'line'"></line-chart>
                <pie-chart :data="expensesData" v-else-if="chartType == 'pie'"></pie-chart>
                <scatter-chart :data="expensesData" v-else-if="chartType == 'scatter'"></scatter-chart>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm4>
          <h5 class="mt-4 ml-2">Finance Statement Summary</h5>
          <h6 class="ml-2">Incomes</h6>
          <v-data-table
            :headers="headers"
            :items="incomes"
            hide-default-header
            hide-default-footer
            class="elevation-1 mr-4"
          ></v-data-table>
          <h6 class="ml-2 mt-4">Incomes Total : {{getCurrency}} {{incomesTotal}}</h6>

          <br />
          <v-btn outlined class="ml-2" rounded small>Expenses</v-btn>
          <v-data-table
            :headers="headers"
            :items="expenses"
            hide-default-header
            hide-default-footer
            class="elevation-1"
          ></v-data-table>
          <h6 class="ml-2 mt-4">Expenses Total : {{getCurrency}} {{expensesTotal}}</h6>
          <br />
          <h6 class="ml-2">Net Profit : {{getCurrency}} {{netTotal}}</h6>
        </v-flex>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";

export default {
  components: {
    DashboardHeader,
    DatePickerWithMenu
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    }
  },
  mounted() {
    this.$store.commit("setLoader", true);

    axios
      .getData("/auth/get-initial-finance-dashboard-data", this.getAccessToken)
      .then(data => {
        this.incomesCategories = data.incomesCats;
        this.expensesCategories = data.expensesCats;

        data.incomesCats.forEach(incCat => {
          this.selectedIncomesCategories.push(incCat.id);
        });

        data.expensesCats.forEach(expCat => {
          this.selectedExpensesCategories.push(expCat.id);
        });
        this.renderCharts();
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    dateFrom: new Date().toISOString().substr(0, 10),
    dateTo: new Date(new Date().getFullYear(), 11, 32)
      .toISOString()
      .substr(0, 10),
    headers: [
      { text: "Description", value: "description" },
      { text: "Amount", value: "amount" }
    ],
    incomesCategories: [],
    expensesCategories: [],
    selectedIncomesCategories: [],
    selectedExpensesCategories: [],
    expenses: [],
    incomes: [],
    expensesTotal: 0,
    incomesTotal: 0,
    netTotal: 0,
    expensesData: [],
    incomesData: [],
    charts: [
      { text: "Vertical Bars", value: "column" },
      { text: "Horizontal Bars", value: "bar" },
      { text: "Pie Chart", value: "pie" },
      { text: "Line Chart", value: "line" },
      { text: "Scatter", value: "scatter" }
    ],
    selectedChart: null,
    chartType: "column"
  }),
  methods: {
    getChartType() {
      this.chartType = this.selectedChart;
    },
    getFromDate(dateFrom) {
      this.dateFrom = dateFrom;
      this.renderCharts();
    },
    getToDate(dateTo) {
      this.dateTo = dateTo;
      this.renderCharts();
    },
    renderCharts() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-selected-finance-dashboard-data",
          {
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            selectedIncomesCategories: this.selectedIncomesCategories,
            selectedExpensesCategories: this.selectedExpensesCategories
          },
          this.getAccessToken
        )
        .then(data => {
          this.incomesData = [];
          this.incomesTotal = 0;
          this.expensesData = [];
          this.expensesTotal = 0;
          this.incomes = data.incomesData;
          this.expenses = data.expensesData;
          data.incomesData.forEach(inc => {
            this.incomesData.push([inc.description, inc.amount]);
            this.incomesTotal += Number(inc.amount);
          });

          data.expensesData.forEach(exp => {
            this.expensesData.push([exp.description, exp.amount]);
            this.expensesTotal += Number(exp.amount);
          });
          this.netTotal = this.incomesTotal - this.expensesTotal;
          this.incomesTotal = axios.formatMoney(this.incomesTotal.toFixed(2));
          this.expensesTotal = axios.formatMoney(this.expensesTotal.toFixed(2));
          this.netTotal = axios.formatMoney(this.netTotal.toFixed(2));
          this.$store.commit("setLoader", false);
        });
    }
  }
};
</script>

<style>
</style>